import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function PacificaBuilderTradesTriggerFullDetails({ trigger }: Props) {
  const builderCodeDisplay = useMemo(() => {
    const builderCode = trigger.context?.builderCode;
    if (!builderCode) return '-';
    return <Badge size="sm">{builderCode as string}</Badge>;
  }, [trigger.context?.builderCode]);

  const executedWhenDisplay = useMemo(() => {
    return (
      <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
        <Text as="span" variant="body-sm" color="muted">
          User trades on
        </Text>
        <Badge size="sm">Pacifica</Badge>
        <Text as="span" variant="body-sm" color="muted">
          platform
        </Text>
      </div>
    );
  }, []);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed when" value={executedWhenDisplay} />
      <KeyValueRow label="Builder Code" value={builderCodeDisplay} />
      <KeyValueRow label="Volume Expression" value={trigger.volumeExpression ?? '-'} />
      <KeyValueRow label="Revenue Expression" value={trigger.revenueExpression ?? '-'} />
      <KeyValueRow label="Volume Currency" value={trigger.currencyVolumeExpression ?? '-'} />
      <KeyValueRow label="Revenue Currency" value={trigger.currencyRevenueExpression ?? '-'} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
